import Services from '../../services/services';

export const checkEventStatus = async (userId, eventId, eventUniqueNo) => {
  //single event data
  try {
    const res = await Services.single_event_details(
      userId,
      eventId,
      eventUniqueNo
    );
    if (res.data.responseCode === 200) {
      if (res.data.listOfHostEvents[0]['eventStatus'] === 'active') {
        return {
          streamDetails: res.data.listOfHostEvents[0],
          eventStatus: true,
          removeUserFromStream: false,
        };
      }
      return { eventStatus: 'Event not started', removeUserFromStream: true };
    }
  } catch (error) {
    return {
      eventStatus: 'Please check your internet',
      removeUserFromStream: false,
    };
  }
};
